import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { string } from 'prop-types';

import TaskContent, {
  propTypes as taskContentPropTypes,
} from '~/components/DailyTasksView/TaskWrapper/TaskContent';

import { offerCountSelector } from '~/redux/selectors';
import { EXPLORATION_QUEST_PATH } from '~/routes/paths';

import style from './TaskWrapper.module.scss';

// eslint-disable-next-line import/prefer-default-export
export function ExplorationTask({ image, ...rest }) {
  const offersCount = useSelector(offerCountSelector);
  const completed = !offersCount;

  return (
    <Link
      to={EXPLORATION_QUEST_PATH}
      className={style.explorationTask}
    >
      <TaskContent
        completed={completed}
        path={image}
        {...rest}
      >
        {Boolean(offersCount) && (
          <div className={style.offerCount}>{offersCount}</div>
        )}
      </TaskContent>
    </Link>
  );
}

ExplorationTask.propTypes = {
  ...taskContentPropTypes,
  image: string.isRequired,
};
